// Request Item Form - Success Message & Rate Limiting
class RequestItemForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.productId = this.dataset.productId || 'default';
    this.cooldownMinutes = 15; // 15-20 minutes as requested
    this.cooldownMs = this.cooldownMinutes * 60 * 1000;
    
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
      this.checkCooldown();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    
    // Check if still in cooldown
    if (this.isInCooldown()) {
      this.showCooldownMessage();
      return;
    }

    // Submit the form
    const formData = new FormData(this.form);
    fetch(this.form.action, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (response.ok) {
        this.showSuccessMessage();
        this.setCooldown();
        this.form.reset();
      }
    })
    .catch(error => {
      console.error('Form submission error:', error);
      this.showErrorMessage();
    });
  }

  isInCooldown() {
    const lastSubmit = localStorage.getItem(`request_item_cooldown_${this.productId}`);
    if (!lastSubmit) return false;
    
    const elapsed = Date.now() - parseInt(lastSubmit);
    return elapsed < this.cooldownMs;
  }

  getTimeRemaining() {
    const lastSubmit = localStorage.getItem(`request_item_cooldown_${this.productId}`);
    if (!lastSubmit) return 0;
    
    const elapsed = Date.now() - parseInt(lastSubmit);
    const remaining = Math.ceil((this.cooldownMs - elapsed) / 1000);
    return remaining > 0 ? remaining : 0;
  }

  setCooldown() {
    localStorage.setItem(`request_item_cooldown_${this.productId}`, Date.now().toString());
    this.updateButtonState();
  }

  checkCooldown() {
    if (this.isInCooldown()) {
      this.updateButtonState();
      this.startCooldownTimer();
    }
  }

  updateButtonState() {
    const remaining = this.getTimeRemaining();
    if (remaining > 0) {
      this.submitButton.disabled = true;
      const minutes = Math.ceil(remaining / 60);
      this.submitButton.textContent = `Request again in ${minutes}m`;
      this.submitButton.classList.add('button--disabled');
    } else {
      this.submitButton.disabled = false;
      this.submitButton.textContent = 'Request this item';
      this.submitButton.classList.remove('button--disabled');
    }
  }

  startCooldownTimer() {
    const interval = setInterval(() => {
      const remaining = this.getTimeRemaining();
      if (remaining <= 0) {
        clearInterval(interval);
        this.updateButtonState();
      } else {
        const minutes = Math.ceil(remaining / 60);
        this.submitButton.textContent = `Request again in ${minutes}m`;
      }
    }, 1000);
  }

  showSuccessMessage() {
    const message = document.createElement('div');
    message.className = 'request-item-success-message';
    message.textContent = '✓ Your request has been sent successfully!';
    message.style.cssText = `
      background-color: #4caf50;
      color: white;
      padding: 12px 16px;
      border-radius: 4px;
      margin-bottom: 16px;
      animation: slideDown 0.3s ease-out;
    `;
    
    this.form.parentElement.insertBefore(message, this.form);
    
    setTimeout(() => {
      message.style.animation = 'slideUp 0.3s ease-out';
      setTimeout(() => message.remove(), 300);
    }, 3000);
  }

  showCooldownMessage() {
    const remaining = this.getTimeRemaining();
    const minutes = Math.ceil(remaining / 60);
    alert(`Please wait ${minutes} minute(s) before submitting another request.`);
  }

  showErrorMessage() {
    const message = document.createElement('div');
    message.className = 'request-item-error-message';
    message.textContent = '✗ There was an error sending your request. Please try again.';
    message.style.cssText = `
      background-color: #f44336;
      color: white;
      padding: 12px 16px;
      border-radius: 4px;
      margin-bottom: 16px;
    `;
    
    this.form.parentElement.insertBefore(message, this.form);
    
    setTimeout(() => message.remove(), 5000);
  }
}

customElements.define('request-item-form', RequestItemForm);

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideUp {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
  
  .button--disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
document.head.appendChild(style);